import React from 'react';
import { TRACKING } from 'common/constants/constants';
import CtaPage from 'components/CtaPage';
import { TEXT_POSITION } from 'components/CtaPage/constants';
import ImgteamsCta from 'images/teamsCta.jpg';
import { DUMMY_SECTION_TEAMS } from './constants';
import { CTA_PAGE_TEXTS } from 'views/root/views/home/views/dashboard/doraV2/dashboard.doraV2.freeTier.consts';

const SECTION_TYPES = {
  TEAM_MEMBER: 'TEAM_MEMBER'
};

const TEXTS = {
  [SECTION_TYPES.TEAM_MEMBER]:
    'Standardize reporting across all engineering teams and provide a ' +
    ' predictable framework for keeping the organization informed about' +
    ' where developers are spending their time.'
};

const TeamGoalsCTA = () => {
  return (
    <CtaPage
      textsMap={TEXTS}
      page={TRACKING.PAGES.TEAMS}
      pageTab={TRACKING.PAGE_TABS.TEAMS}
      buttonLineProps={{
        textWidth: '60%',
        leftText: CTA_PAGE_TEXTS.METRICS_TEAMS_TEXT,
        buttonText: CTA_PAGE_TEXTS.METRICS_TEAMS_BUTTON
      }}
      backgroundImage={ImgteamsCta}
      sections={[
        {
          sectionType: SECTION_TYPES.TEAM_MEMBER,
          buttonPosition: {
            left: '15.2rem',
            top: '23.3rem'
          },
          coverProps: {
            height: '40rem',
            width: '24rem',
            position: { top: '4,3rem', left: '14rem' }
          },
          textPosition: { left: TEXT_POSITION, top: '17.7rem' },
          isTextLeft: true
        }
      ].concat(DUMMY_SECTION_TEAMS)}
    />
  );
};

export default TeamGoalsCTA;
